<template>
    <div style="padding: 15px;height: 100vh">
        <div class="app-content">
            <a-card title="ประวัติการแจ้งลา">
                <template #extra>
                    <a-space>
                        <a-button v-if="businessTypeId==3" @click="showModalExport = true" type="primary" size="large">
                            ออกรายงานการลา
                        </a-button>
                        <a-button style="display: flex" type="primary" size="large" @click="goLeaveHistory()">
                            ย้อนกลับ
                        </a-button>
                    </a-space>
                </template>
            </a-card>

            <a-space style="width: 100%; margin-top: 20px">
                <a-input-search v-model:value="search_input" placeholder="ค้นหาชื่อผู้ขับ" enter-button="Search"
                    style="width: 350px;" />

                <a-range-picker v-model:value="datetime" />

                <a-button @click="clear_search()" type="dashed">CLEAR</a-button>
            </a-space>
            <div style="display: flex; margin-top: 20px;">
                <a-table :columns="columnsLeave" :dataSource="filtered_table(data)" bordered size="small"
                    :scroll="{ x: 'calc(100px + 50%)', y: '500px' }">
                    <template #bodyCell="{ column, record }">
                        <template v-if="column.key === 'approve'">
                            <p style="color: #389e0d;" v-if="record.approve === 1">อนุมัติ</p>
                            <p style="color: #ff4d4f;" v-if="record.approve === 2">ไม่อนุมัติ</p>
                        </template>
                        <template v-if="column.key === 'approver'">
                            <p v-if="record.approver != null">
                                {{ operation_approver.find((opApp)=>opApp.id == record.approver).fullname}} 
                                {{ operation_approver.find((opApp)=>opApp.id == record.approver).nickname? `(${operation_approver.find((opApp)=>opApp.id == record.approver).nickname})`: ''}}
                            </p>
                        </template>
                        <template v-if="column.key === 'action'">
                            <div>
                                <a-tooltip>
                                    <template #title>ดูข้อมูล</template>
                                    <a @click="show_modal(record.id)"><span style="font-size: 14px"
                                            class="material-symbols-outlined">visibility</span></a>
                                </a-tooltip>
                            </div>

                        </template>
                    </template>
                </a-table>
            </div>
        </div>
    </div>

    <a-modal :title="'ออกรายงานการลา'" v-model:visible="showModalExport" @ok="showModalExport=false" >
        <a-form layout="vertical">
            <a-row type="flex">
                <a-col :span="24">
                    <a-form-item style="width: 98%;" :rules="[{ required: true, message: 'กรุณากรอกชื่อ-นามสกุลผู้ขับ' }]">
                        <span style="color: red; margin-right: 3px;">*</span><span>ชื่อ-นามสกุลผู้ขับ</span>
                        <a-checkbox v-model="allDriver" style="margin-left: 8px; margin-right: 5px; margin-bottom: 8px;" @change="handleCheckboxDriverChange">
                            ทั้งหมด
                        </a-checkbox>
                        <a-select v-model:value="search_leave_user" placeholder="ชื่อ-นามสกุลผู้ขับ" :disabled="allDriver == true">
                            <a-select-option
                                v-for="({ id, name }, i) in driver_list"
                                :key="i"
                                :value="name"
                            >{{ name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item style="width: 98%;" :rules="[{ required: true, message: 'กรุณากรอกประเภทการลา' }]">
                        <span style="color: red; margin-right: 3px;">*</span><span>ประเภทการลา</span>
                        <a-checkbox v-model="allLeaveTypes" style="margin-left: 8px; margin-right: 5px; margin-bottom: 8px;" @change="handleCheckboxChange">
                            ทั้งหมด
                        </a-checkbox>
                        <a-select v-model:value="search_leave_type" placeholder="ประเภทการลา" :disabled="allLeaveTypes == true">
                            <a-select-option
                                v-for="({ id, name }, i) in filtered_leave_types"
                                :key="i"
                                :value="name"
                            >{{ name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="วันที่เริ่ม" style="width: 98%;" :rules="[{ required: true, message: 'กรุณากรอกวันที่เริ่ม' }]">
                        <a-date-picker v-model:value="search_start_date" style="width: 100%;"></a-date-picker>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="วันที่สิ้นสุด" style="width: 98%;" :rules="[{ required: true, message: 'กรุณากรอกวันที่สิ้นสุด' }]">
                        <a-date-picker v-model:value="search_end_date" style="width: 100%;"></a-date-picker>
                    </a-form-item>
                </a-col>
            </a-row>
        </a-form>
        <template #footer>
            <a-button type="primary" @click="validateFields">
                บันทึก
            </a-button>
        </template> 
    </a-modal>

    <a-modal v-model:visible="visible" :title="'แก้ไขการแจ้งลา'" :closable="false" footer>
        <a-form :model="modal_form">
            <a-row class="row-spacing">
                <a-col class="gutter-row" :span="6">
                    <div class="gutter-box label-container">
                        <p class="label-text">ชื่อ-นามสกุลผู้ขับ:</p>
                    </div>
                </a-col>
                <a-col class="gutter-row" :span="18">
                    <div class="gutter-box value-container">
                        <p class="value-text">{{ modal_form.name }}</p>
                    </div>
                </a-col>
            </a-row>
            <a-row class="row-spacing">
                <a-col class="gutter-row" :span="6">
                    <div class="gutter-box label-container">
                        <p class="label-text">วันที่แจ้งลา:</p>
                    </div>
                </a-col>
                <a-col class="gutter-row" :span="18">
                    <div class="gutter-box value-container">
                        <p class="value-text">{{ modal_form.created_at }}</p>
                    </div>
                </a-col>
            </a-row>
            <a-row class="row-spacing">
                <a-col class="gutter-row" :span="6">
                    <div class="gutter-box label-container">
                        <p class="label-text">วันที่ลาเริ่มต้น:</p>
                    </div>
                </a-col>
                <a-col class="gutter-row" :span="18">
                    <div class="gutter-box value-container">
                        <p class="value-text">{{ modal_form.time_start }}</p>

                    </div>
                </a-col>
            </a-row>
            <a-row class="row-spacing">
                <a-col class="gutter-row" :span="6">
                    <div class="gutter-box label-container">
                        <p class="label-text">วันที่ลาสิ้นสุด:</p>
                    </div>
                </a-col>
                <a-col class="gutter-row" :span="18">
                    <div class="gutter-box value-container">
                        <p class="value-text">{{ modal_form.time_end }}</p>
                    </div>
                </a-col>
            </a-row>
            <a-row class="row-spacing">
                <a-col class="gutter-row" :span="6">
                    <div class="gutter-box label-container">
                        <p class="label-text">จำนวนวันลา:</p>
                    </div>
                </a-col>
                <a-col class="gutter-row" :span="18">
                    <div class="gutter-box value-container">
                        <p class="value-text">{{ modal_form.days }}</p>
                    </div>
                </a-col>
            </a-row>
            <a-row class="row-spacing">
                <a-col class="gutter-row" :span="6">
                    <div class="gutter-box label-container">
                        <p class="label-text">ประเภทการลา:</p>
                    </div>
                </a-col>
                <a-col class="gutter-row" :span="18">
                    <div class="gutter-box value-container">
                        <p class="value-text">{{ modal_form.leave_type }}</p>
                    </div>
                </a-col>
            </a-row>
            <a-row class="row-spacing">
                <a-col class="gutter-row" :span="6">
                    <div class="gutter-box label-container">
                        <p class="label-text">โควตาการลา:</p>
                    </div>
                </a-col>
                <a-col class="gutter-row" :span="18">
                    <div class="gutter-box value-container">
                        <p class="value-text">{{ modal_form.leave_quota }}</p>
                    </div>
                </a-col>
            </a-row>
            <a-row class="row-spacing">
                <a-col class="gutter-row" :span="6">
                    <div class="gutter-box label-container">
                        <p class="label-text">ผลอนุมัติ:</p>
                    </div>
                </a-col>
                <a-col class="gutter-row" :span="18">
                    <div class="gutter-box value-container">
                        <p style="color: #389e0d;" v-if="modal_form.approve === 1" class="value-text">อนุมัติ</p>
                        <p style="color: #ff4d4f;" v-if="modal_form.approve === 2" class="value-text">ไม่อนุมัติ</p>
                    </div>
                </a-col>
            </a-row>
            <a-row class="row-spacing">
                <a-col class="gutter-row" :span="6">
                    <div class="gutter-box label-container">
                        <p class="label-text">ใบลา:</p>
                    </div>
                </a-col>
            </a-row>
            <div v-if="modal_form.photo != null && modal_form.photo != ''" class="image-container">
                <img :src="modal_form.photo" class="uploaded-image-table" alt="uploaded image" />
                <div class="icon-container">
                    <span class="material-symbols-outlined preview-icon" @click="showPreview($event, modal_form.photo)">
                        visibility
                    </span>
                    <span class="material-symbols-outlined download-icon"
                        @click="getBase64Image($event, modal_form.photo)">
                        download
                    </span>
                </div>
            </div>
            <a-row class="row-spacing">
                <a-col class="gutter-row" :span="6">
                    <div class="gutter-box label-container">
                        <p class="label-text">หมายเหตุ:</p>
                    </div>
                </a-col>
            </a-row>
            <a-row class="row-spacing">
                <a-col class="gutter-row" :span="24">
                    <div class="gutter-box value-container">
                        <p class="textarea-like">{{ modal_form.remark }}</p>
                    </div>
                </a-col>
            </a-row>
            <a-row class="row-spacing">
                <a-col class="gutter-row" :span="6">
                    <div class="gutter-box label-container">
                        <p class="label-text">ชื่อผู้อนุมัติการลา:</p>
                    </div>
                </a-col>
                <a-col class="gutter-row" :span="18" >
                    <div class="gutter-box value-container">
                        <p class="value-text">
                            {{ 
                                modal_form.approver? 
                                operation_approver.find((opApp)=>opApp.id == modal_form.approver).fullname +
                                ` (${operation_approver.find((opApp)=>opApp.id == modal_form.approver).nickname})`
                                :' '
                            }}
                        </p>
                    </div>
                </a-col>
            </a-row> 

            <div style="display: flex; width: 100%; justify-content: end; gap: 5px;">
                <a-form-item>
                    <a-button @click="close_modal(modal_form.id)" type="">ปิด</a-button>
                </a-form-item>
            </div>
            <a-modal v-model:visible="previewVisible" :footer="null" :mask="false" @cancel="previewVisible = false"
                class="custom-modal" style="background-color: none !important">
                <img :src="previewImage" alt="Preview" style="width: 100%;" />
            </a-modal>
        </a-form>
    </a-modal>

</template>

<script>
import Swal from 'sweetalert2';
import dayjs from "dayjs";
const duration = require('dayjs/plugin/duration')
dayjs.extend(duration)
import LeaveService from "../../api/LeaveService";
import SystemService from "../../api/SystemService";
import UserService from '../../api/UserService';
import CompanyService from '../../api/CompanyService';
import DriverService from '../../api/DriverService';
import HumanResourceService from '../../api/HumanResourceService ';
import XLSX from "xlsx-js-style";


export default ({
    computed:{
        columnsLeave(){
            const columns = [
                {
                    title: 'ชื่อ-นามสกุลผู้ขับ',
                    dataIndex: 'name',
                    key: 'name',
                    width: 350,
                    align: 'center',
                },
                {
                    title: 'วันที่แจ้งลา',
                    dataIndex: 'created_at',
                    key: 'created_at',
                    width: 200,
                },
                {
                    title: 'วันที่ลา',
                    dataIndex: 'date',
                    key: 'date',
                    width: 250,
                },
                {
                    title: 'จำนวนวัน',
                    dataIndex: 'days',
                    key: 'days',
                    width: 125,
                },
                {
                    title: 'ประเภทการลา',
                    dataIndex: 'leave_type',
                    key: 'leave_type',
                    width: 125,
                },
            ];
            if (this.businessTypeId === 4) {
                columns.push({
                    title: 'โควตาการลา',
                    dataIndex: 'leave_quota',
                    key: 'leave_quota',
                    width: 150,
                    align: 'center',
                });
            }
            columns.push(
                {
                    title: 'การอนุมัติ',
                    dataIndex: 'approve',
                    key: 'approve',
                    width: 250,
                    align: 'center',
                },
                {
                    title: 'ชื่อผู้อนุมัติการลา',
                    dataIndex: 'approver',
                    key: 'approver',
                    width: 250,
                    align: 'center',
                },
                {
                    title: 'ตัวเลือก',
                    key: 'action',
                    width: 125,
                    align: 'center',
                    fixed: 'right',
                }
            );
            return columns
        },
        leave_quota_limits() {
            return this.businessTypeId === 4
                ? {
                    4: 7,  // ลากิจ: 7 ครั้ง/ปี
                    6: 12,  // ลาพักร้อน: 12 ครั้ง/ปี
                    5: 30, // ลาป่วย: 30 ครั้ง/ปี
                    10: null, // ลาชาปนกิจ: ไม่มีเงื่อนไข
                }
                : {
                    4: 3,  // ลากิจ: 3 ครั้ง/ปี
                    6: 8,  // ลาพักร้อน: 8 ครั้ง/ปี
                    5: 30, // ลาป่วย: 30 ครั้ง/ปี
                    9: null, // ลาแบบไม่รับค่าจ้าง: ไม่มีเงื่อนไข
                    10: null, // ลาชาปนกิจ: ไม่มีเงื่อนไข
                };
        },
    },
    data() {
        return {
            search_input: null,
            datetime: null,
            data: [],
            leave_response: [],
            operation_approver: [],
            approve: null,
            visible: false,
            modal_form: {},
            previewImage: "",
            previewVisible: false,
            businessTypeId:null,
            showModalExport: false,
            filtered_leave_types: [],
            driver_list: [],
            allLeaveTypes: false,
            allDriver: false,
            search_leave_type: null,
            search_leave_user: null,
            search_start_date: null,
            search_end_date: null,
        };
    },
    methods: {
        handleCheckboxChange() {
            this.allLeaveTypes = !this.allLeaveTypes;
            if (this.allLeaveTypes) {
                this.search_leave_type = null;
            }
        },
        handleCheckboxDriverChange() {
            this.allDriver = !this.allDriver;
            if (this.allDriver) {
                this.search_leave_user = null;
            }
        },
        validateFields() {
            const isUserValid = this.allDriver || !!this.search_leave_user;
            const isTypeValid = this.allLeaveTypes || !!this.search_leave_type;
            const isStartDateValid = !!this.search_start_date;
            const isEndDateValid = !!this.search_end_date;

            if (!isUserValid) {
                this.$message.error('กรุณากรอกผู้ส่งคำขอ');
            }
            if (!isTypeValid) {
                this.$message.error('กรุณากรอกประเภทการลา');
            }
            if (!isStartDateValid) {
                this.$message.error('กรุณากรอกวันที่เริ่ม');
            }
            if (!isEndDateValid) {
                this.$message.error('กรุณากรอกวันที่สิ้นสุด');
            }

            if (isUserValid && isTypeValid && isStartDateValid && isEndDateValid) {
                this.import_export_dropdown();
            }
        },
        import_export_dropdown() {
            this.export_file()
            this.showModalExport = false
        },
        async export_file() {
            this.$message.loading({ content: "กำลังโหลด...", key: "loading" });
            const filteredData = this.data.filter(item => {
                const matchesUser = this.allDriver || (item.name && item.name.includes(this.search_leave_user));
                const matchesType = this.allLeaveTypes || item.leave_type === this.search_leave_type;
                const matchesStartDate = !this.search_start_date || dayjs(item.time_start).isSameOrAfter(dayjs(this.search_start_date), 'day');
                const matchesEndDate = !this.search_end_date || dayjs(item.time_end).isSameOrBefore(dayjs(this.search_end_date), 'day');
                const matchesDate = matchesStartDate && matchesEndDate;
                return matchesUser && matchesType && matchesDate;
            }).map(item => {
                const baseItem = {
                    fullname: item.name || '-',
                    leave_timestamp: item.created_at,
                    leave_date_period: item.date,
                    leave_days: item.days,
                    leave_type: item.leave_type,
                    approve: item.approve == 1 ? 'อนุมัติ': 'ไม่อนุมัติ',
                    approver: this.operation_approver.find((opa)=>item.approver == opa.id).fullname + ` (${this.operation_approver.find((opa)=>item.approver == opa.id).nickname})`
                };

                return baseItem;
            });

            const headersColumn = [
                { header: "ชื่อ-นามสกุลผู้ขับ", key: "fullname" },
                { header: "วันที่แจ้งลา", key: "leave_timestamp" },
                { header: "วันที่ลา", key: "leave_date_period" },
                { header: "จำนวนวัน", key: "leave_days" },
                { header: "ปรเภทการลา", key: "leave_type" },
                { header: "การอนุมัติ", key: "approve" },
                { header: "ชื่อผู้อนุมัติการลา", key: "approver" },
            ];

            const workBook = XLSX.utils.book_new();
            const workSheet = XLSX.utils.json_to_sheet(filteredData, { header: headersColumn.map(h => h.key) });

            XLSX.utils.sheet_add_aoa(workSheet, [headersColumn.map(h => h.header)], { origin: 'A1' });

            headersColumn.forEach((header, colIndex) => {
                const cellAddress = XLSX.utils.encode_cell({ c: colIndex, r: 0 });
                const cell = workSheet[cellAddress];
                if (cell) {
                    cell.s = {
                        font: { bold: true, color: { rgb: "000000" } }, // color text
                        fill: { fgColor: { rgb: "FAF052" } }, // color background
                        alignment: { horizontal: "center", vertical: "center" },
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } }
                        }
                    };
                }
            });

            const range = XLSX.utils.decode_range(workSheet['!ref']);
            for (let R = range.s.r + 1; R <= range.e.r; ++R) {
                for (let C = range.s.c; C <= range.e.c; ++C) {
                    const cellAddress = XLSX.utils.encode_cell({ c: C, r: R });
                    const cell = workSheet[cellAddress];
                    if (cell) {
                        cell.s = cell.s || {};
                        cell.s.alignment = { horizontal: "center", vertical: "center" };
                        cell.s.border = {
                            top: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } }
                        };
                    }
                }
            }

            workSheet['!cols'] = [
                { wch: 25 },
                { wch: 15 },
                { wch: 30 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 25 },
            ];

            XLSX.utils.book_append_sheet(workBook, workSheet, "Report");
            XLSX.writeFile(workBook, "LeaveHistory.xlsx");
            this.$message.success({ content: "โหลดข้อมูลสำเร็จ", key: "loading" });
        },
        show_modal(id) {
            const data = this.data.find((item) => item.id === id);
            // console.info("show_modal", data)
            this.modal_form = {
                id: data.id,
                name: data.name,
                days: data.days,
                date: [dayjs(data.time_start), dayjs(data.time_end)],
                leave_type: data.leave_type,
                time_start: data.time_start,
                time_end: data.time_end,
                approve: data.approve,
                leave_quota: data.leave_quota,
                created_at: data.created_at,
                approver: data.approver,
                photo: data.photo,
                remark: data.remark
            }
            this.visible = true;
        },
        showPreview(e, fileUrl) {
            e.stopPropagation();
            this.previewImage = fileUrl;
            this.previewVisible = true;
        },
        async getBase64Image(e, file) {
            e.stopPropagation();
            e.preventDefault();

            if (typeof file === 'string') {
                const result = await this.getBase64ImageFromURL(file);
                let a = document.createElement('a');
                a.href = result;
                a.download = 'image.png';
                a.click();
            } else if (file.url) {
                const result = await this.getBase64ImageFromURL(file.url);

                // download
                let a = document.createElement('a');
                a.href = result;
                a.download = 'image.png';
                a.click();
            } else {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => {
                    const base64String = reader.result;
                    let a = document.createElement('a');
                    a.href = base64String;
                    a.download = 'image.png';
                    a.click();
                };
            }
        },
        async getBase64ImageFromURL(url) {
            const res = await fetch(url, {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer'
            });
            const blob = await res.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },
        close_modal(id) {
            this.visible = false;
        },
        goLeaveHistory() {
            this.$router.back();
        },
        dateCheck(id, value) {
            const driver_id = this.data.find((item) => item.id === id).driver_id;
            const driver = this.leave_response.filter((item) => item.driver_id === driver_id && item.id !== id && item.approve === 1);

            if (driver.length >= 1) {
                var count = 0;
                var date = {};
                driver.forEach((item) => {
                    const start = dayjs(item.time_start).startOf('day').unix();
                    const end = dayjs(item.time_end).startOf('day').unix();
                    const [time_start, time_end] = value.map(item => dayjs(item).startOf('day').unix());
                    if ((time_start >= start && time_start <= end) || (time_end >= start && time_end <= end)) {
                        count++;
                        date = { time_start: dayjs(item.time_start).format("YYYY/MM/DD"), time_end: dayjs(item.time_end).format("YYYY/MM/DD") }
                        return;
                    }
                });
                if (count > 0) {
                    Swal.fire({
                        title: `วันที่ลาซ้ำกับวันที่ลาไปแล้ว!`,
                        text: `วันที่ลาไปแล้ว ${date.time_start} - ${date.time_end}`,
                        icon: 'warning',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: `ตกลง`,
                    });
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        },
        async on_submit(id) {
            this.visible = false;
            if (this.modal_form.leave_type == "ลากิจ") this.modal_form.leave_type = 4
            else if (this.modal_form.leave_type == "ลาป่วย") this.modal_form.leave_type = 5
            const data = {
                time_start: this.modal_form.date[0],
                time_end: this.modal_form.date[1],
                work_status_id: parseInt(this.modal_form.leave_type),
            }
            await SystemService.update_all('Leave', { data: data }, id).then(() => {
                Swal.fire({
                    icon: 'success',
                    title: 'แก้ไขการแจ้งลาสำเร็จ',
                    showConfirmButton: false,
                    timer: 1000
                });
                this.get_leaves();
            })
        },
        handleChange(id, value) {
            const index = this.data.findIndex((item) => item.id === id);
            this.data[index].approve = parseInt(value);
            // console.log(this.data[index]);
        },
        async send_approve(id) {
            const index = this.data.findIndex((item) => item.id === id);
            if (this.data[index].approve === 0) {
                Swal.fire({
                    icon: 'error',
                    title: 'กรุณาเลือกการอนุมัติ',
                    showConfirmButton: false,
                    timer: 1000
                });
            } else {
                const driver = this.data.find((item) => item.id === id)
                if (this.data[index].approve === 2) { // กรณีไม่อนุมัติ
                    await SystemService.update_all('Leave', { data: { approve: this.data[index].approve } }, id).then(() => {
                        Swal.fire({
                            icon: 'success',
                            title: 'ส่งแจ้งเตือนการอนุมัติสำเร็จ',
                            showConfirmButton: false,
                            timer: 1500
                        });
                    });
                    this.get_leaves();
                } else { // กรณีอนุมัติ
                    const check = this.dateCheck(id, [driver.time_start, driver.time_end])
                    if (check) {
                        await SystemService.update_all('Leave', { data: { approve: this.data[index].approve, is_valid: 1 } }, id)
                        // await SystemService.update_all('Driver', { data: { work_status_id: this.leave_response[index].work_status_id,
                        //     leave_status: this.leave_response[index].work_status_id, leave_date: this.data[index].time_start,}},
                        //     this.data[index].driver_id);
                        Swal.fire({
                            icon: 'success',
                            title: 'ส่งแจ้งเตือนการอนุมัติสำเร็จ',
                            showConfirmButton: false,
                            timer: 1500
                        });
                        this.get_leaves();
                    }
                }
            }
        },
        remove_leave(id) {
            Swal.fire({
                title: `คุณต้องการลบใช่หรือไม่?`,
                text: `คุณจะไม่สามารถกู้คืนได้`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: `ใช่`,
                cancelButtonText: 'ยกเลิก'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await SystemService.delete_all('Leave', id).then(() => {
                        Swal.fire('ลบข้อมูลสำเร็จ', '', 'success');
                        this.get_leaves();
                    });
                } else if (result.isDenied) {
                    Swal.fire('ข้อมูลไม่ถูกลบ', '', 'info');
                }
            });
        },
        edit_leave_type(value) {
            this.modal_form.work_status_id = parseInt(value)
        },
        clear_search() {
            this.search_input = null;
            this.datetime = null;
            this.data = [];
            this.get_leaves();
        },
        filtered_table(array) {
            return array.filter((item) => {
                if (this.search_input) {
                    return item.name.includes(this.search_input);
                }
                return true;
            })?.filter((item) => {
                if (this.datetime) {
                    const [time_start, time_end] = this.datetime.map(item => dayjs(item).startOf('day').unix())
                    const start = dayjs(item.time_start).startOf('day').unix();
                    const end = dayjs(item.time_end).startOf('day').unix();
                    return start >= time_start && end <= time_end;
                }
                return true;
            });
        },
        async get_leaves() {
            this.data = [];
            this.leave_response = await LeaveService.getLeaveDriver('HISTORY');
            const response = this.leave_response
            // console.log(this.leave_response);
            function calDays(date1, date2) {
                const startDate = dayjs(date1).startOf('day')
                const endDate = dayjs(date2).startOf('day')
                const diffInDays = endDate.diff(startDate, 'day')
                return diffInDays == 0 ? 1 : diffInDays + 1;
            }
            for (let i = 0; i < response.length; i++) {
                let leaveQuotaData 
                if(response[i].approve == 1 || response[i].approve == 2){
                    leaveQuotaData = await DriverService.leavequotaused(response[i]?.driver?.company_id, response[i]?.driver_id,response[i]?.id);
                }else{
                    leaveQuotaData = await DriverService.leavequota(response[i]?.driver?.company_id, response[i]?.driver_id);      
                }          
                leaveQuotaData = leaveQuotaData.data;
                const quota = leaveQuotaData.find(q => q.leave_type_id === response[i].work_status_id);
                const usedQuota = quota ? quota.count : 0;
                const totalQuota = this.leave_quota_limits[response[i].work_status_id] || '-';
                this.data.push({
                    id: response[i].id,
                    driver_id: response[i].driver_id,
                    name: response[i].driver.firstname + ' ' + response[i].driver.lastname,
                    created_at: response[i].notification_date? dayjs(response[i].notification_date).format("YYYY/MM/DD") : dayjs(response[i].created_at).format("YYYY/MM/DD"),
                    time_start: dayjs(response[i].time_start).format("YYYY/MM/DD"),
                    time_end: dayjs(response[i].time_end).format("YYYY/MM/DD"),
                    date: dayjs(response[i].time_start).format("YYYY/MM/DD") + ' - ' + dayjs(response[i].time_end).format("YYYY/MM/DD"),
                    days: (typeof response[i].count_leave === 'number') && response[i].count_leave >= 0 ? response[i].count_leave : calDays(dayjs(response[i].time_start), dayjs(response[i].time_end)),
                    leave_quota: totalQuota !== '-' ? `${usedQuota}/${totalQuota}` : '-',
                    leave_type: response[i].work_status.name,
                    approve: response[i].approve,
                    approver: response[i].approver_id,
                    photo: response[i].photo_1,
                    remark: response[i].remark_leave
                });
            }
            this.driver_list = Array.from(
                new Map(this.data.map(item => [item.name, item])).values()
            ).map(item => ({ id: item.id, name: item.name }));
        },
        async get_approver(){
            const operationList = await SystemService.get_all('Operation');
            const hrList = await HumanResourceService.getHumanResourceByCompany();
            this.operation_approver = [...operationList,...hrList];
            const data = await UserService.get_user_profile();
            const businessType = await CompanyService.getBusinessId(data.company_id);
            this.businessTypeId = businessType.data;
            const leaveType = await DriverService.getDriverLeaveWorkStatus();
            this.filtered_leave_types = leaveType.data;
        }
    },
    async mounted() {
        await this.get_approver();
        this.get_leaves();
    },
});
</script>
<style scoped>
.label-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
}

.label-text {
    margin: 0;
    padding-right: 1.5rem;
}

.row-spacing {
    margin-bottom: 16px;
}

.value-container {
    display: flex;
    align-items: center;
    height: 100%;
}

.value-text {
    /* background-color: #f5f5f5; */
    border: 1px solid #d9d9d9;
    color: #000000;
    padding: 4px 12px;
    border-radius: 16px;
    box-sizing: border-box;
    flex: 1;
    text-align: center;
    margin: 0;
}

.image-container {
    position: relative;
    display: inline-block;
    margin-bottom: 16px
}

.uploaded-image-table {
    display: block;
    width: 10rem;
    height: auto;
}

.icon-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 4px;
    padding: 5px;
}

.preview-icon,
.download-icon {
    cursor: pointer;
    font-size: 20px;
    color: black;
}

.custom-modal ::v-deep .ant-modal-content {
    box-shadow: none;
    background-color: transparent;
}

.custom-modal ::v-deep .ant-modal-body {
    padding: 0;
}
.textarea-like {
    /* background-color: #f5f5f5; */
    border: 1px solid #d9d9d9;
    color: #000000;
    padding: 8px 12px;
    border-radius: 4px;
    min-height: 90px;
    line-height: 1.5; 
    white-space: pre-wrap;
    box-sizing: border-box;
    width: 100%;
    overflow: hidden;
}
.custom-select ::v-deep .ant-select-selector {
  border-radius: 25px !important; 
  border: 1px solid #d9d9d9; 
  padding: 4px; 
}
</style>